import { AwardListResource } from "../generated-api";
import ApiClient from "@/api/ampm-world";

export class ApiAward {
  static async getAwards(lang: string): Promise<AwardListResource> {
    return ApiClient.get(`/${lang}/awards`);
  }
}
